import { apiClient } from '../../../gateways/api'
import type { Opdracht } from '../../types/Opdracht'

export { fetchCombiOpdracht }

const fetchCombiOpdracht = async (id: string): Promise<Opdracht> => {
  const { data } = await apiClient({
    url: `/rest/opdracht/${id}`,
    method: 'GET',
  })

  return data
}
